/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import OpacityPreLoader from 'components/Common/PreLoaders/OpacityPreLoader';
import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';
import groupsSearchCollector from 'components/Hocs/GroupsSearchCollector/GroupsSearchCollector';

class UserRoomsSearchBlock extends Component {
  constructor(props) {
    super(props);
    this.props.initState(true);
    this.handleSearch();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.searchInput !== this.props.searchInput &&
      this.props.searchInput !== ''
    ) {
      this.props.initState(true);
      this.handleSearch();
    }
  }

  showMore = () => {
    if (
      this.props.pagination.currentPage !== this.props.pagination.pageCount &&
      this.props.pagination.currentPage !== 0
    ) {
      this.props.changeQueryParams({
        page: this.props.pagination.currentPage + 1
      });
      this.props.sendRequest();
    }
  };

  hasShowMore = () =>
    this.props.pagination.currentPage !== this.props.pagination.pageCount &&
    this.props.pagination.totalCount > 0;

  handleSearch = () => {
    this.props.changeQueryParams({ search: this.props.searchInput });
    this.props.sendRequest();
  };

  render() {
    if (
      !this.props.requestState.inProgress &&
      this.props.itemsIds.length === 0
    ) {
      return (
        <div className="alert alert-default text-center" style={{ margin: 0 }}>
          <p>По вышему запросу ничего не найдено :-(</p>
        </div>
      );
    }
    return (
      <React.Fragment>
        <div>
          {this.props.requestState.inProgress &&
          this.props.itemsIds.length === 0 ? (
            <MediumPreLoader />
          ) : null}
          {this.props.itemsIds.map(itemId => {
            const item = this.props.selectItemById(itemId);
            return (
              <Link
                to={`/main/messenger/room/${item.userRoom.roomUuid}`}
                className={classNames('panel-notify')}
              >
                <div className="media">
                  <div
                    className="media media_comment media_comment_default"
                    key={`roomMessage-${item.id}`}
                  >
                    <a
                      href=""
                      className="media-left"
                      onClick={e => {
                        e.preventDefault();
                      }}
                    >
                      <img
                        alt=""
                        className="media-object avatar avatar-sm"
                        src={item.userRoom.picture}
                      />
                    </a>
                    <div className="media-body media-middle full-width">
                      <div className="media-info">
                        <a
                          href=""
                          className="media-info-name"
                          onClick={e => {
                            e.preventDefault();
                          }}
                        >
                          {item.userRoom.roomName}
                        </a>
                        <span className="media-info-desc">
                          {item.createdAtFormatted}
                        </span>
                      </div>
                      <div className="media-content-data">
                        {item.username}: {item.messageContent}
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
        {this.hasShowMore() ? (
          <div
            className="alert alert-default text-center"
            style={{ margin: 0 }}
          >
            {this.props.requestState.inProgress ? <OpacityPreLoader /> : null}
            <a
              href=""
              onClick={e => {
                e.preventDefault();
                this.showMore();
              }}
            >
              Показать ещев
            </a>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

UserRoomsSearchBlock.propTypes = {
  initState: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
  sendRequest: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  showMore: PropTypes.func.isRequired,
  hasShowMore: PropTypes.func.isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired
};

export default groupsSearchCollector({
  msgs: {
    component: UserRoomsSearchBlock,
    listReduceName: 'messengerModule.lists.personalUniversalSearchList'
  }
});



// WEBPACK FOOTER //
// ./src/components/Messenger/content/UserRoomsList/UserRoomsSearchBlock.js